import React from "react";
import PropTypes from "prop-types";
import Dropzone from "dropzone";
import {
  Button,
  ListGroupItem,
  ListGroup,
  Row,
  Col,
} from "reactstrap";

Dropzone.autoDiscover = false;

class Dropzones extends React.Component {

  componentDidMount() {
    //console.log("componentDidMount")
    const { autoProcessQueue = true, uploadUrl = "./", maxFiles, maxFilesize, acceptedFiles, initDropzone, ...rest } = this.props;
    // this variable is to delete the previous image from the dropzone state
    // it is just to make the HTML DOM a bit better, and keep it light
    // 이걸로 왜 HTML DOM이 더 가벼워지는게 이해가 안 되지만 일단 유지 
    let currentMultipleFile = undefined;

    this.dropzone = new Dropzone(document.getElementById("dropzone-multiple"), {
      autoProcessQueue: autoProcessQueue,
      url: uploadUrl,
      thumbnailWidth: null,
      thumbnailHeight: null,
      previewsContainer: document.getElementsByClassName(
        "dz-preview-multiple"
      )[0],
      previewTemplate: document.getElementsByClassName("dz-preview-multiple")[0].innerHTML,
      maxFiles: maxFiles,
      maxFilesize: maxFilesize,
      acceptedFiles: acceptedFiles,
      initDropzone: initDropzone,
      init: function() {
        this.options.initDropzone(this);
        this.on("addedfile", function(file) {
          if (currentMultipleFile) {
          }
          currentMultipleFile = file;

          // 자동으로 업로드 되지 않는 경우에만 적용 (자동으로 업로드 되는 경우에는 성공하는 경우에만 success에서 처리함)
          if( !this.options.autoProcessQueue && typeof(this.options.addFileAtState) == 'function' ) {
            this.options.addFileAtState(file);
          }

          switch (file.type) {// pdf파일인 경우 썸네일 지정 (추후 화면 UI를 바꾸거나 확장자별 썸네일을 추가해주어야 함)
            case 'application/msword':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/doc-icon.png");
              break;

            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/docx-icon.png");
              break;

            case 'application/pdf':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/pdf-icon.png");
              break;

              case 'application/vnd.ms-powerpoint':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/ppt-icon.png");
              break;

            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/pptx-icon.png");
              break;

            case 'text/plain':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/txt-icon.png");
              break;

            case 'application/vnd.ms-excel':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/xls-icon.png");
              break;

            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/xlsx-icon.png");
              break;

            default:
              file.previewElement.querySelectorAll("[data-dz-thumbnail]")[0].src = require("assets/img/icons/common/file-icon.png");
              break;
          }

        });
        // 자동으로 업로드 되는 경우에만 호출됨 (수동의 경우에는 Dropzone이 아닌 saga를 통해서 업로드하도록 함)
        this.on("success", function (file, response)  {
          if( typeof(this.options.addFileAtState) == 'function' ) {
            this.options.addFileAtState(file, response);
          }
        });

        this.on("removedfile", function(file) {
          if( typeof(this.options.removeFileAtState) == 'function' ) {
            this.options.removeFileAtState(file);
          }
        });

        this.on("error", function (file)  {
          if( typeof(this.options.removeFileAtState) == 'function' ) {
            this.options.removeFileAtState(file);
          }
        });
        /*
        this.on("processing", function (file)  {
          //console.log("Dropzone - processing")
        });
        this.on("queuecomplete", function (file)  {
          //console.log("Dropzone - queuecomplete")
        });
        this.on("complete", function (file)  {
          //console.log("Dropzone - complete")
        });
        this.on("canceled", function (file)  {
          //console.log("Dropzone - canceled")
        });
        this.on("sending", function (file)  {
          //console.log("Dropzone - sending	")
        });
        this.on("uploadprogress", function (file)  {
          //console.log("Dropzone - uploadprogress	")
        });
        */
      },
      ...rest
    });

    document.getElementsByClassName("dz-preview-multiple")[0].innerHTML = "";
  }

  render() {
    return (
      <>
        <div className="dropzone dropzone-multiple" id="dropzone-multiple">
          <div className="dz-message">
            마우스로 파일을 끌어오시거나, 여기를 클릭하세요.<br /><br />
            <span className="text-warning">
              <i className="ni ni-bell-55 " />{" "}
               업로드된 파일은 서버에 저장되지 않습니다.
            </span>
          </div>
          <ListGroup
            className=" dz-preview dz-preview-multiple list-group-lg"
            flush
          >
            <ListGroupItem className=" px-0">
              <Row className=" align-items-center">
                <Col className=" col-auto">
                  {/* <div className=" avatar"> */}
                  <div>
                    <img
                      alt="..."
                      //className=" avatar-img rounded"
                      data-dz-thumbnail
                      src="..."
                    />
                  </div>
                </Col>
                <div className=" col ml--3">
                  <h4 className=" mb-1" data-dz-name>
                    ...
                  </h4>
                  <p className=" small text-muted mb-0" data-dz-size>
                    ...
                  </p>
                  <p className=" small text-warning mb-0" data-dz-errormessage>
                    ...
                  </p>
                </div>
                <Col className=" col-auto">
                  <Button size="sm" color="danger" data-dz-remove>
                    <i className="fas fa-trash" />
                  </Button>
                </Col>
              </Row>
            </ListGroupItem>
          </ListGroup>
        </div>
      </>
    );
  }
}

Dropzones.propTypes = {
  autoProcessQueue: PropTypes.bool,
  uploadUrl: PropTypes.string,
  maxFiles: PropTypes.number.isRequired,
  maxFilesize: PropTypes.number.isRequired,
  acceptedFiles: PropTypes.string.isRequired,
  initDropzone: PropTypes.func.isRequired,
};

export default Dropzones;